import { createContext, useContext } from 'react'
import type { DarkWebPageState } from './useDarkWebPageState'

// The page's state and handlers, so each tab can use what it needs without prop drilling
export const DarkWebContext = createContext<DarkWebPageState | null>(null)

export function useDarkWebPage(): DarkWebPageState {
  const value = useContext(DarkWebContext)
  if (!value) throw new Error('useDarkWebPage must be used inside the Dark Web page')
  return value
}
